module.exports = __webpack_public_path__ + "static/img/35.031c26b1.gif";